export const VEHICLE_TYPES = {
    LITE: 'LITE',
    BIKE: 'BIKE',
};
